module.exports = __webpack_public_path__ + "static/media/a93.a8d6956c.jpg";